import { WhiteLabelData } from 'reactApp/modules/WhiteLabelModule/WhiteLabelModule.types';

const greenatom: WhiteLabelData = {
    billing_settings: {
        available_payment_methods: [],
        enabled: true,
    },
    partner_services: [],
    support_contacts: {
        email: '',
        question_form_url: '',
        phone: '',
    },
    available_services: [
        'bigdata',
        'containers',
        'databases',
        'gpu',
        'hotbox',
        'infra',
        'vision',
        'marketplace',
    ],
    tag: 'greenatom',
    ui_settings: {
        page_title: 'Greenatom',
        theme: 'Greenatom',
        hide_external_links: true,
        hide_access_control: true,
        hide_project_creation: true,
    },
};

const X5: WhiteLabelData = {
    billing_settings: {
        enabled: true,
        available_payment_methods: [],
    },
    available_services: ['containers', 'databases', 'infra', 'marketplace'],
    terraform: {
        auth_url: 'https://xcloud.x5.ru/identity/v3/',
    },
    partner_services: [
        {
            title: 'Документация',
            // eslint-disable-next-line sonarjs/no-duplicate-string
            url: 'https://wiki.x5.ru/display/X5CLOUD',
            icon: 'file',
        },
    ],
    networks_creation_disabled: true,
    cidr: '100.127.0.0/24',
    ui_settings: {
        page_title: 'X5 CLOUD',
        main_page_header: 'X5 CLOUD',
        theme: 'X5',
    },
    support_contacts: {
        support_link: 'https://wiki.x5.ru/display/X5CLOUD',
        help_link: 'https://wiki.x5.ru/display/X5CLOUD',
        question_form_url: 'https://wiki.x5.ru/display/X5CLOUD',
        email: 'x5cloud-support@x5.ru',
    },
    marketplace: {
        url: '/marketplace_templates',
    },
    maxVMNameLength: 8,
    serverNameGenerationType: 'random',
    serverNameUniqueness: true,
    isExtIpDisabled: true,
};

export const WhitelabelConfigs = {
    greenatom,
    X5,
};
